import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { useLocale, useSetLocale, useTranslate } from 'react-admin';

const LocaleSwitcher = () => {
	const translate = useTranslate();
	const setLocale = useSetLocale();
	const locale = useLocale();

	return (
		<Select value={locale} label={translate('LANGUAGE')} onChange={({ target: { value } }: any) => {
			setLocale(value);
			const elements = [document.querySelector('.App'), document.body, document.querySelector('html')];

			elements.forEach(element => {
				if (element)
					element.setAttribute('dir', value === 'he' || value === 'ar' ? 'rtl' : 'ltr');
			});
		}}>
			<MenuItem value="en">
				{translate('ENGLISH')}
			</MenuItem>
			<MenuItem value="es">
				{translate('SPANISH')}
			</MenuItem>
			<MenuItem value="pt">
				{translate('PORTUGEUSE')}
			</MenuItem>
			<MenuItem value="it">
				{translate('ITALIAN')}
			</MenuItem>
			<MenuItem value="he">
				{translate('HEBREW')}
			</MenuItem>
		</Select>
	);
};

export default LocaleSwitcher;
